var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTxt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1440",
    "data-name": "Group 1440",
    transform: "translate(-1148 -304)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_783",
    "data-name": "Rectangle 783",
    width: 24,
    height: 24,
    transform: "translate(1148 304)",
    fill: "#e6e6e6",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1439",
    "data-name": "Group 1439",
    transform: "translate(488.455 -232.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4745",
    "data-name": "Path 4745",
    d: "M663.545,555.508v2.873a.958.958,0,0,0,.958.958h13.1a.958.958,0,0,0,.958-.958V544l-6.837-6.837H664.5a.958.958,0,0,0-.958.958v17.834",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#363639",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4746",
    "data-name": "Path 4746",
    d: "M672.806,537.167v6.424a.413.413,0,0,0,.412.413h6.424",
    transform: "translate(-1.083 0)",
    fill: "none",
    stroke: "#363639",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_628",
    "data-name": "Line 628",
    x2: 8.962,
    transform: "translate(666.559 547.091)",
    fill: "none",
    stroke: "#363639",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_629",
    "data-name": "Line 629",
    x2: 7.234,
    transform: "translate(666.559 550.022)",
    fill: "none",
    stroke: "#363639",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_630",
    "data-name": "Line 630",
    x2: 4.34,
    transform: "translate(666.559 555.884)",
    fill: "none",
    stroke: "#363639",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_631",
    "data-name": "Line 631",
    x2: 8.962,
    transform: "translate(666.559 552.953)",
    fill: "none",
    stroke: "#363639",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTxt);
export default __webpack_public_path__ + "static/media/icon-txt.ca19abee641289e7873e8b4502f45e2d.svg";
export { ForwardRef as ReactComponent };